import { gql } from '../../../../../hooks'

export const DELETE_LOGICS = gql`
  mutation AdministrationDeleteAnalysisLogics($id: ID!) {
    aDelete(path: "analysis/logics", id: $id) {
    }
  }
`

export const LIST_LOGICS = gql`
  query AdministrationListAnalysisLogics(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "analysis/logics"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
